import { nanoid } from 'nanoid';

import { ListModel } from '@/models/ListModel';

import { AddAlertParams, AlertParams, IAlertsStore } from './types';

// Время показа нотификации, мс
const ALERT_VISIBLE_TIME = 3000;

const STRIP_HTML_RE = /<[^>]*>/g;
const stripHtml = (text: string): string => text.replace(STRIP_HTML_RE, '');

export class AlertsStore implements IAlertsStore {
  static readonly _alerts: ListModel<AlertParams> = new ListModel<AlertParams>();

  get alerts() {
    return AlertsStore._alerts;
  }

  addAlert = (params: AddAlertParams) => {
    const key = nanoid();

    const sanitized: AddAlertParams = {
      ...params,
      message: stripHtml(params.message),
      title: params.title ? stripHtml(params.title) : params.title,
    };

    AlertsStore._alerts.addEntity({ key, entity: { id: key, ...sanitized } });

    if (params.autoClose) {
      setTimeout(() => this.removeAlert(key), ALERT_VISIBLE_TIME);
    }

    return key;
  };

  removeAlert = (id: AlertParams['id']): void => {
    AlertsStore._alerts.removeEntity(id);
  };
}
